<template>
  <div class="min-w-320" :class="{ [`theme--${theme}`]: true }">
    <router-view />
    <Toast :notificationState="toastNotifications" @close="closeToastMessage" />
    <ModalsContainer />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { ModalsContainer } from 'vue-final-modal';
import text2speech from '@/helpers/text2speech';

export default {
  name: 'App',
  components: { ModalsContainer },
  computed: {
    ...mapState(['toastNotifications', 'theme']),
  },
  methods: {
    ...mapActions(['showToastMessage', 'bootstrap', 'closeToastMessage']),
    setVisualViewportHeight() {
      const height = window.visualViewport?.height;
      const r = document.querySelector(':root');
      r.style.setProperty('--vvh', `${height}px`);
    },
  },
  created() {
    this.bootstrap();
    text2speech.stopSpeaking();
  },
  mounted() {
    if ('visualViewport' in window) {
      this.setVisualViewportHeight();
      window.visualViewport.addEventListener('resize', () => {
        this.setVisualViewportHeight();
      });
    }
  },
};
</script>
<style lang="scss">
.grecaptcha-badge {
  display: none !important;
}
.monaco-editor .rename-box {
  display: none;
}
</style>
